import React, {Component} from 'react';
import {Base64} from 'js-base64';
import '../products.scss';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import commaNumber from 'comma-number';
import {fetchProducts, fetchAndOpenPaymentPopup, fetchAndOpenAutoPaymentPopup} from '../../../actions/purchase.actions';
import {fetchCurrentUserDetailRequest} from '../../../actions/user.actions';

import './purchaseMethodSelect.scss';
import {Button, ButtonGroup, PcBangPopup, Table} from '../../Common/PageComponents';
import {convertPcBangPointToTimeCredit, convertTimeCreditToPcBangPoint} from '../../../util/timeUtils';

const PAYMENT_CYCLE = {
  ONCE: {
    name: '일반결제',
    types: [
      {
        type: 'CREDIT_CARD',
        name: '신용카드',
      },
      {
        type: 'ACCOUNT_TRANSFER',
        name: '계좌이체',
      },
      {
        type: 'VIRTUAL_ACCOUNT',
        name: '가상계좌',
      },
    ],
  },
  AUTO: {
    name: '자동결제',
    types: [
      {
        type: 'AUTOMATIC_PAYMENT_BY_CREDIT_CARD',
        name: '신용카드 자동결제',
      },
      {
        type: 'AUTOMATIC_PAYMENT_BY_ACCOUNT_TRANSFER',
        name: '계좌이체 자동결제',
      },
    ],
  },
};

const stateToProps = state => {
  return {
    products: state.purchase.products,
    user: state.user,
  };
};

class PurchaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentCycle: 'ONCE',
      paymentType: PAYMENT_CYCLE.ONCE.types[0].type,
      productId: '',
      price: 0,
      timeCredit: 0,
      autoPaymentConfirmOpen: false,
      autoPaymentPointInTimeCredit: '',
      autoPaymentAgreement: false,
      password: '',
      agreeForSmsService: true,
    };
  }

  componentDidMount() {
    this.props.dispatch(fetchProducts());
    this.props.dispatch(fetchCurrentUserDetailRequest());
  }

  _changePaymentCycle(paymentCycle) {
    this.setState({
      paymentCycle: paymentCycle,
      paymentType: PAYMENT_CYCLE[paymentCycle].types[0].type,
      autoPaymentAgreement: false,
    });
  }

  _changePaymentType(paymentType) {
    this.setState({
      paymentType: paymentType,
    });
  }

  _changePrice(productId) {
    if (this.props.products[productId]) {
      this.setState({
        productId: productId,
        price: this.props.products[productId].price,
        timeCredit: this.props.products[productId].timeCredit,
      });
    } else {
      this.setState({
        productId: '',
        price: 0,
        timeCredit: 0,
      });
    }
  }

  _proceedPayment(e) {
    e.preventDefault();
    if (this.state.paymentCycle === 'AUTO') {
      if (this.props.user.autoPayment && !this.props.user.autoPayment.paused) {
        alert('이미 자동결제중 입니다.');
        return;
      }

      if (this.state.autoPaymentPointInTimeCredit === '') {
        alert('결제시점을 선택해 주세요.');
        return;
      }

      if (!this.state.price) {
        alert('결제 금액을 선택해 주세요.');
        return;
      }

      if (!this.state.autoPaymentAgreement) {
        alert('자동 결제에 동의 해주세요. ');
        return;
      }
      this.setState({autoPaymentConfirmOpen: true});
    } else {
      if (!this.state.productId || this.state.productId === 'NONE') {
        alert('결제 금액을 선택해 주세요.');
        return;
      }
      this.props.dispatch(fetchAndOpenPaymentPopup(this.state.paymentType, this.state.productId));
    }
  }

  _proceedAutoPayment(e) {
    e.preventDefault();

    this.setState({autoPaymentConfirmOpen: false});
    this.props.dispatch(
      fetchAndOpenAutoPaymentPopup(
        this.state.paymentType,
        this.state.productId,
        this.state.password,
        this.state.autoPaymentPointInTimeCredit,
        this.state.agreeForSmsService
      )
    );
  }

  handleAutoPaymentPoints = e => {
    this.setState({
      autoPaymentPointInTimeCredit: e.target.value,
    });
  };

  render() {
    return (
      <div className="purchase-form">
        <dl className="form">
          <dt>결제주기</dt>
          <dd>
            {Object.keys(PAYMENT_CYCLE).map(key => {
              return (
                <label key={key}>
                  <input
                    type="radio"
                    name="paymentCycle"
                    value={key}
                    onClick={e => this._changePaymentCycle(e.target.value)}
                    defaultChecked={this.state.paymentCycle === key}
                  />
                  {PAYMENT_CYCLE[key].name}
                </label>
              );
            })}
          </dd>
          <dt>결제금액</dt>
          <dd>
            <select name="amount" style={{width: 132}} onChange={e => this._changePrice(e.target.value)}>
              <option value={'NONE'}>선택하세요.</option>
              {Object.keys(this.props.products)
                .sort((o1, o2) => this.props.products[o1].price - this.props.products[o2].price)
                .map(key => (
                  <option key={key} value={key}>
                    {commaNumber(this.props.products[key].price)} 원
                  </option>
                ))}
            </select>
          </dd>
          {this.state.paymentCycle == 'AUTO' ? this._renderAutoPaymentCondition() : null}
          <dt>결제방식</dt>
          <dd>
            {PAYMENT_CYCLE[this.state.paymentCycle].types.map(paymentType => {
              return (
                <label key={paymentType.type}>
                  <input
                    id="credit-card"
                    type="radio"
                    name="pgType"
                    defaultChecked={paymentType.type == this.state.paymentType}
                    value={paymentType.type}
                    onClick={e => this._changePaymentType(e.target.value)}
                  />
                  {paymentType.name}
                </label>
              );
            })}
          </dd>
        </dl>
        <div style={{marginLeft: '100px'}}>
          <div style={{textAlign: 'right'}}>※ VAT 포함</div>
          <dl className="purchase-box">
            <dt>결제금액</dt>
            <dd id="price">{commaNumber(this.state.price)} 원</dd>
            <dt>구매포인트</dt>
            <dd id="displayPoint">{convertTimeCreditToPcBangPoint(this.state.timeCredit)}</dd>
          </dl>
          {this.state.paymentCycle == 'AUTO' ? this._renderAutoPaymentGuide() : null}
          <div style={{textAlign: 'center', margin: '25px 0'}}>
            <span style={{color: '#E80000', fontWeight: 'bold', marginRight: '5px'}}>
              {commaNumber(this.state.price)}
            </span>
            원을 바로 결제하고 구매하시겠습니까?
          </div>
          <div className="centbtn">
            <Button onClick={e => this._proceedPayment(e)} style={{marginRight: '10px'}}>
              구매
            </Button>
            <Link to="/products/guide">
              <Button theme="gray">취소</Button>
            </Link>
          </div>
          <div style={{marginTop: '20px', textAlign: 'center', color: 'red'}}>
            인터넷 익스플로러 10.0 이하 버전의 브라우저를 사용해 결제할 경우 결제 오류가 발생할 수 있습니다.
            <br />
            최신 버전의 브라우저를 사용해 결제해주시기 바랍니다.
          </div>
        </div>
        {this._renderAutoPaymentModal()}
      </div>
    );
  }

  _renderAutoPaymentGuide() {
    return (
      <div style={{padding: '10px 5px', background: '#F3F3F3', textAlign: 'center', marginTop: '20px'}}>
        <span className=" fc_04 lh15">
          &apos;자동결제&apos;를 선택하실 경우, 선택하신 &apos;결제시점&apos; 미만의 시간이 남았을 때, 현재 선택하신
          상품이 &apos;자동결제&apos;가 됩니다.
        </span>
        <br />
        <span className=" fc_04 lh15">
          차후 &apos;자동결제&apos;를 중지하려면, &apos;MY PC방&apos; &gt; &apos;자동결제신청/변경&apos;페이지에서 해지
          신청이 가능합니다.
        </span>
        <br />
        <span className=" fc_04 b">자동결제를 신청하시겠습니까?</span>
        <br />
        <br />
        <label>
          <input
            type="checkbox"
            name="agreement"
            onChange={() => this.setState({autoPaymentAgreement: !this.state.autoPaymentAgreement})}
          />
          <span className="fc_02"> 네,자동결제에 동의합니다</span>
        </label>
      </div>
    );
  }

  _renderAutoPaymentCondition() {
    return (
      <React.Fragment>
        <dt>결제시점</dt>
        <dd>
          <AutoPaymentPoints name="autoPaymentTime" onChange={this.handleAutoPaymentPoints} style={{width: 132}} />
        </dd>
      </React.Fragment>
    );
  }

  _renderAutoPaymentModal() {
    return (
      <PcBangPopup
        open={this.state.autoPaymentConfirmOpen}
        closeOnDocumentClick={false}
        contentStyle={{width: '700px'}}
        title={this.state.paymentType == 'AUTOMATIC_PAYMENT_BY_CREDIT_CARD' ? '신용카드승인' : '계좌이체승인'}
        onClose={() => this.setState({autoPaymentConfirmOpen: false})}
      >
        <Table>
          <colgroup>
            <col width={150} />
            <col width={350} />
          </colgroup>
          <tbody>
            <tr>
              <th>결제금액</th>
              <td>
                <label id="ctl00_ContentPlaceHolder1_lbPayAmt">{commaNumber(this.state.price)}</label> 원
              </td>
            </tr>
            <tr id="personNo">
              <th>비밀번호</th>
              <td>
                <input
                  onChange={e => this.setState({password: Base64.encode(e.target.value)})}
                  type="password"
                  id="txtData"
                  maxLength={50}
                  className="text"
                  autoComplete="off"
                />
                <p style={{marginTop: '5px'}}>(본인의 프리미엄 PC방 비밀번호를 입력)</p>
              </td>
            </tr>
            <tr>
              <th height="40px">
                새벽시간 결제실패
                <br />
                안내SMS 수신동의
              </th>
              <td>
                <input
                  type="radio"
                  name="agreeForSmsService"
                  value="true"
                  onChange={e => this.setState({agreeForSmsService: e.target.value})}
                  defaultChecked
                />{' '}
                수신동의
                <input
                  type="radio"
                  style={{marginLeft: '20px'}}
                  name="agreeForSmsService"
                  value="false"
                  onChange={e => this.setState({agreeForSmsService: e.target.value})}
                />{' '}
                수신안함
              </td>
            </tr>
          </tbody>
        </Table>
        <div>
          ※ 자동결제 실패 시, 실패 안내 SMS가 전송되며 30분 후 자동결제를 재시도합니다. <br />
          &nbsp;&nbsp;&nbsp;&nbsp;자동결제 2회 실패 시 재시도 시점이 익일로 연기되오니, <br />
          &nbsp;&nbsp;&nbsp;&nbsp;실패 안내 SMS 수신 시 자동결제 수단 점검을 부탁드립니다. <br />
          &nbsp;&nbsp;&nbsp;&nbsp;새벽시간(00:00~07:00)에 SMS 수신을 원하지 않을 경우,
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;수신안함을 선택해주시기 바랍니다. <br />
          <br />
        </div>
        <ul className="pay">
          <li>결제가 완료될 때까지 새로고침을 하거나 결제창을 닫지 마세요.</li>
          <li>카드이용명세서에는 ‘라이엇 게임즈’로 표시됩니다</li>
          <li>보안처리된 페이지이므로 안전하게 사용할 수 있습니다.</li>
        </ul>
        <ButtonGroup>
          <Button onClick={e => this._proceedAutoPayment(e)}>확인</Button>
          <Button theme={'gray'} onClick={() => this.setState({autoPaymentConfirmOpen: false})}>
            취소
          </Button>
        </ButtonGroup>
      </PcBangPopup>
    );
  }
}

export const AutoPaymentPoints = props => (
  <select {...props}>
    <option value="">선택하세요</option>
    {[15000, 35000, 50000, 100000, 150000].map(point => (
      <option key={point} value={convertPcBangPointToTimeCredit(point)}>
        {commaNumber(point)} pt
      </option>
    ))}
  </select>
);

export default connect(stateToProps)(PurchaseForm);
